import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Checkbox, Icon, Dropdown, Card, Input } from "semantic-ui-react";
import { questionsOperations } from "./../../../../redux/questions";
import { Wrapper } from "./style.js";
import IconButton from "./../../../../components/IconButton";
import axios from "axios";
import _ from "lodash";
import clsx from "clsx";
import DebriefStatus from './components/DebriefStatus';
import DebriefDashboard from './components/DebriefDashboard';
import { navActions } from "./../../../../redux/nav";
import { LS_SELECTED_DEBRIEF_KEY } from './util';

class Debriefs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      showingCreateForm: false,
      inputValue: '',
      debrieferScrollbar: false,
      debriefs: null,
    };

    this.cardRef = React.createRef();
    this.getDebriefs = this.getDebriefs.bind(this);
    this.showCreateForm = this.showCreateForm.bind(this);
    this.hideCreateForm = this.hideCreateForm.bind(this);
    this.submitCreateForm = this.submitCreateForm.bind(this);
    this.closeDebrief = this.closeDebrief.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidMount() {
    const needsScrollbar = this.debrieferRef && this.debrieferRef.scrollHeight > this.debrieferRef.clientHeight;
    this.setState({
      debrieferScrollbar: needsScrollbar,
    });
  }

  getDebriefs() {
    axios
      .get(`/api/report/${this.props.summaryReport.datasetId}/${this.props.unit}/debriefs`)
      .then(res => {
        if(res.status === 200) {
          const debriefs = res.data;
          const activeDebriefs = debriefs && debriefs.filter((debrief) => debrief.id);
          this.setState({ debriefs: activeDebriefs })
        }
      });
  }

  hideCreateForm() {
    this.setState({
      inputValue: '',
      showingCreateForm:false
    });
  }

  closeDebrief() {
    this.props.dispatch(navActions.closeDebrief())
  }

  showCreateForm() {
    this.setState({
      inputValue: '',
      showingCreateForm:true
    });
    const cardRef = this.cardRef;
    setTimeout(() => {
      cardRef.current.scrollIntoView(({ behavior: 'smooth', block: 'center'}));
    }, 50);
  }

  submitCreateForm() {
    const {
      summaryReport,  
      unit,
      user
    } = this.props;

    this.setState({
      submitting:true
    });

    axios.post(`/api/report/debrief/`, {
        dataset_id: summaryReport.datasetId,
        resultset_id: summaryReport.resultSetId,
        unit: unit,
        shift: this.state.inputValue,
        system: summaryReport.system,
        datasetName: summaryReport.datasetName,
      survey: summaryReport.survey
    }).then(result => {

        //save this debrief as the selected one
        localStorage.setItem(LS_SELECTED_DEBRIEF_KEY, JSON.stringify({ id: result.data.id }));

      window.location = `${user.debriefServerUrl}/api/redirect/connect?unit=${encodeURIComponent(unit)}&return=${window.location.href}&name=${summaryReport.datasetName}&dataset=${summaryReport.datasetId}&loc=${result.data.location_id}&debrief=${result.data.id}&stage=prepare`
    })

  }

  handleKeyPress = (event) => {
    if(event.key === 'Enter'){
      this.submitCreateForm();
    }
  }

  updateInputValue(evt) {
    this.setState({
      inputValue: evt.target.value
    });
  }

  render() {
    const { summaryReport, unit, nav, sharedSummaryReport } = this.props;
    const { showingCreateForm, submitting, inputValue, debrieferScrollbar } = this.state;
    let debriefs = this.state.debriefs || summaryReport.debriefs.filter((d) => d.unit === unit && d.id);
    const hasDebriefs = debriefs && debriefs.length > 0;
    const showDashboard = !unit;

    return (
      <Wrapper className={nav.debriefOpen ? "" : "hide"} noMargin={debrieferScrollbar} innerRef={(ref) => (this.debrieferRef = ref)}>
        <div className="interior">
          <div className="sidebar-header">
            Debriefer
          <button className="black close-button" onClick={this.closeDebrief}><i aria-hidden="true" className="close icon"></i></button>
          </div>
          <div className="heading">
            <img className="title" src="/debriefer-logo.png" alt="Debriefer Logo" />
            {!showDashboard && <h3 className="subtitle">{unit} Survey Debrief</h3>}
            {showDashboard && <h3 className="subtitle">{summaryReport.datasetName}</h3>}
          {!hasDebriefs && !showDashboard && <p>A survey debrief will give the unit a safe place to share thoughts and give feedback to help influence a plan of action for improvement.</p>}
          {!hasDebriefs && !showDashboard && !showingCreateForm && <button onClick={this.showCreateForm} className="ui primary button" role="button">Create Debrief</button>}
          </div>
          <div className="content">

            {showDashboard && <DebriefDashboard debriefs={debriefs} />}

          {hasDebriefs && !showDashboard && <DebriefStatus debriefs={debriefs} unit={unit} submitting={submitting} getDebriefs={this.getDebriefs} />}
          {hasDebriefs && !showDashboard && !showingCreateForm && <div className="debrief-new">Or <button onClick={this.showCreateForm} className="ui tertiary link button" role="button">create new debrief</button> for a different shift.</div>}

          {showingCreateForm && <Card className={clsx({submitting:submitting})}>
                <Card.Content>
                  <Card.Header>Create a Debrief</Card.Header>
                  <Card.Description>
                    Which group are you going to debrief?
                    <span className="understate">e.g. Day Shift, Night Shift, Nurses, Everyone</span>
                <Input placeholder='Shift Name' onChange={evt => this.updateInputValue(evt)} autoFocus disabled={submitting} maxLength="32" onKeyPress={this.handleKeyPress}/>
                <button className={clsx({ui:true, primary:true, button:true, loading:submitting})} role="button" onClick={this.submitCreateForm} disabled={submitting || inputValue===''}>
                      Create
                    </button>
                    <button className="ui tertiary button" role="button" onClick={this.hideCreateForm}>
                      Cancel
                    </button>
                  </Card.Description>
                </Card.Content>
          </Card>}
            <a ref={this.cardRef}></a>
          </div>
        </div>
      </Wrapper>
    );
  }
}

export default connect(store => {
  return {
    summaryReport: store.summaryReport.summaryReport,
    user: store.user,
    nav: store.nav
  };
})(Debriefs);



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Debriefs/index.jsx